import { GridImage } from "components/PhotoGrid/types";
import Text from "components/Text";
import { useClientTranslation } from "hooks/useClientTranslation";

import { vinGuideStyles } from "./styles";

export type Image = GridImage & {
  title?: string;
};

export const VinGuide = ({ images }: { images: Image[] }) => {
  const { classes } = vinGuideStyles();
  const { t } = useClientTranslation();

  return (
    <>
      {images.map((image, index) => (
        <div key={image.id}>
          {image.title && (
            <Text sizeVariant="lg" id={`${image.id}-title`} className={classes.title}>
              {`${t("global.option")} ${index}: ${image.title}`}
            </Text>
          )}
          <img src={image.src} alt={image.alt} aria-labelledby={`${image.id}-title`} className={classes.image} />
        </div>
      ))}
    </>
  );
};
